import React from 'react'

import { BANNER_HEADLINE, BANNER_BODY } from '@aytm/app/stats/page/sidebar/reports/lib/skipperGuidedReportsConst'
import { openGuidedReportsChat } from '@aytm/app/stats/stores/guidedReportsEntry'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/components/styles/SkipperReportBanner.module.scss'

// Non-dismissible Story-3 intro banner shown in the empty report area while a
// Skipper Report is being created. No close control by design. Clicking it enters
// the guided chat on the create entry, which sends its own opening turn.
const SkipperReportBanner = () => (
  <div className={style.banner} {...pressable(() => openGuidedReportsChat({ entry: 'create' }))}>
    <img className={style.art} src={'/images/stats/skipper-report-banner.png'} alt="" />
    <span className={style.artCornerTopLeft} />
    <span className={style.artCornerTopRight} />
    <span className={style.artCornerBottomLeft} />
    <span className={style.artCornerBottomRight} />
    <div className={style.copy}>
      <div className={style.headline}>{BANNER_HEADLINE}</div>
      <div className={style.body}>{BANNER_BODY}</div>
    </div>
  </div>
)

SkipperReportBanner.displayName = 'SkipperReportBanner'

export default SkipperReportBanner
